import { makeStyles } from '@material-ui/core/styles';

interface IStyleProps {
  size: 'small' | 'medium';
}

const useStyles = makeStyles(() => ({
  chipRoot: (props: IStyleProps) => ({
    borderRadius: props.size === 'small' ? 14 : 20,
    border: '1px solid #eee',
    fontSize: props.size === 'small' ? 14 : 16,
    color: '#061D37',
    backgroundColor: '#fff',
    padding: props.size === 'small' ? '0 4px' : '0 6px',
  }),
  chipLabel: {
    paddingLeft: 5,
    fontWeight: 500,
  },
  chipDeleteIcon: {
    width: 18,
    height: 18,
    color: '#596375',
    pointerEvents: 'none',
    '& > path': {
      fill: '#596375',
    },
  },
  invoiceIcon: {
    width: 18,
    height: 18,
    color: '#596375',
    pointerEvents: 'none',
  },
  customIcon: {
    fontSize: 14,
    width: 14,
    height: 14,
  },
  chipDefault: {
    backgroundColor: '#fff',
  },
}));

export default useStyles;
